import * as React from "react";
import { Stack } from "@mui/material";
import BrowserHeader from "./BrowserHeader";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { BREAKPOINTS } from "../../utils/constants/hooks/breakpoints";
import { useRecoilState } from "recoil";
import { USE_SELECTED_INDEX } from "../../hooks/useSelectedElement";
import { useXoraiaValue } from "../../hooks/useXoraia";
import { useKey } from "react-use";
import { canExecute } from "../../lib/canExecute";
import { useUndo, useRedo } from "recoil-undo";
// import ShowPreview from "../ShowPreview";

const Browser: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const label = useBreakpoint();

  const breakpoint = BREAKPOINTS[label];

  const [index, setIndex] = useRecoilState(USE_SELECTED_INDEX);

  const config = useXoraiaValue();

  React.useEffect(() => {
    setIndex(index);
  }, [breakpoint]);

  // undo-redo

  const undo = useUndo();
  const redo = useRedo();

  useKey("z", (event) => {
    if (canExecute(event)) {
      if (event.shiftKey) {
        console.log("redo");
        redo();
      } else {
        console.log("undo");
        undo();
      }
    }
  });

  const mainProps =
    config.env === "preview"
      ? {
          width: "100vw",
          height: "100vh",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 10000,
        }
      : {
          width: "100%",
          maxWidth: breakpoint.deviceWidth ?? "calc(100vw - 400px)",
          height: "100%",
          // flex: 1,
          border: 0.5,
          position: "relative",
        };

  return (
    <Stack sx={{ transition: "all linear 0.3s", ...(mainProps as any) }}>
      <Stack
        id="X_BROWSER"
        sx={{
          flex: 1,
          bgcolor: "white",
          height: "100%",
          position: "relative",
          overflowY: "scroll",
          overflowX: "visible",

          "& p": { mt: 0 },
        }}
      >
        {config.env !== "preview" && <BrowserHeader breakpoint={label} />}
        <Stack
          sx={{
            flex: 1,
            // minHeight: 400,
            overflowY: "scroll",
            overflowX: "visible",
          }}
        >
          {children}
        </Stack>
      </Stack>
      {/* {config.env === "preview" && <ShowPreview />} */}
    </Stack>
  );
};

export default Browser;
